import React from 'react';
import TagManager from 'react-gtm-module';

const SimpleKakaoButton = ({ channelId, buttonText = '문의하기', mobileText }) => {

  // 카톡 문의 버튼 클릭 시 실행될 함수
  const handleKakaoButtonClick = () => {
    // 1. Data Layer에 이벤트 푸시
    // 'kakao_inquiry_submit'이라는 이름으로 이벤트를 푸시합니다.
    // 이 이름은 GTM 트리거 설정 시 정확히 일치해야 합니다.
    window.dataLayer = window.dataLayer || []; // Data Layer가 초기화되어 있는지 확인
    TagManager.dataLayer({
      dataLayer: {
        event: 'kakao_inquiry_submit', // <<-- GTM 맞춤 이벤트 트리거에 사용할 이름!
        // 필요하다면 추가 데이터 푸시
        kakao_channel_id: channelId,
        button_clicked_text: buttonText,
      }
    });

  };

  return (
    <a
      href={`https://pf.kakao.com/${channelId}/chat`}
      target="_blank"
      rel="noopener noreferrer"
      // onClick 이벤트 핸들러 추가
      onClick={handleKakaoButtonClick} // <<-- 이 부분이 중요!
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: '#FEE500',
        color: '#000000',
        border: 'none',
        borderRadius: '24px',
        padding: '12px 20px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        zIndex: 50,
        textDecoration: 'none'
      }}
    >
      {/* 카카오톡 아이콘 (SVG) */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: '8px' }}
      >
        <path
          d="M128 36C70.562 36 24 72.713 24 118C24 147.67 44.742 173.433 74.743 186.926C73.157 192.09 65.493 215.906 64.848 219.331C64.848 219.331 64.571 221.816 66.179 222.766C67.787 223.715 69.71 222.759 69.71 222.759C74.061 221.273 96.5 204.818 103.038 200.172C111.001 201.387 119.271 202 128 202C185.438 202 232 165.287 232 120C232 74.713 185.438 36 128 36Z"
          fill="#000000"
        />
      </svg>
      {/* 데스크톱 텍스트 */}
      <span className="hidden sm:inline">{buttonText}</span>

      {/* 모바일 텍스트 */}
      <span className="sm:hidden">{mobileText || buttonText}</span>
    </a>
  );
};

export default SimpleKakaoButton;